export default __webpack_public_path__ + "static/logout-96357a57c519cf30d0debd5aeb035657.jpg";